export const patientSummary_style = {
  dividerSx: {
    mt: 1.2,
    borderStyle: 'dashed',
    borderColor: 'divider',
  },
};
